import React from 'react';
import { routes } from '../../modules/routes';
import { AboutUs } from './about-us';
import { FooterBrand } from './footer-brand';
import { FooterLink } from './footer-link';
import { SocialIcons } from './social-icons';
import { TopLink } from './top-link';

import styles from './footer.module.scss';
import { useSelector } from 'react-redux';
import { currentUserHasPricingEnabledSelector } from 'modules/currentUser';

export function Footer() {
    const hasPricingEnabled = useSelector(currentUserHasPricingEnabledSelector);
    return (
        <>
            <TopLink />
            <footer className={styles.footer}>
                <div className={styles.footer_content}>
                    <div>
                        <FooterBrand />
                        <AboutUs />
                        <SocialIcons />
                    </div>
                    <nav>
                        <div>
                            <FooterLink href={routes.home.path} text="Home" />
                            <FooterLink href={routes.explore.path} text="Explore Styles" />
                            <FooterLink href={routes.createStyle.path} text="Create a Style" />
                            <FooterLink href={routes.mapBuilder.path} text="Build a Map" highlight />
                            <FooterLink href={routes.plugins.path} text="Plugins" />
                            <FooterLink href={routes.help.path} text="Help" />
                            <FooterLink href={routes.press.path} text="Press" />
                            {hasPricingEnabled && <FooterLink href={routes.pricing.path} text="Pricing" />}
                        </div>
                        <h4>Tags</h4>
                        <div className={styles.link_grid}>
                            <FooterLink href="/explore?tag=colorful" text="Colorful" />
                            <FooterLink href="/explore?tag=complex" text="Complex" />
                            <FooterLink href="/explore?tag=dark" text="Dark" />
                            <FooterLink href="/explore?tag=greyscale" text="Greyscale" />
                            <FooterLink href="/explore?tag=light" text="Light" />
                            <FooterLink href="/explore?tag=monochrome" text="Monochrome" />
                            <FooterLink href="/explore?tag=no-labels" text="No Labels" />
                            <FooterLink href="/explore?tag=simple" text="Simple" />
                            <FooterLink href="/explore?tag=two-tone" text="Two Tone" />
                        </div>
                        <h4>Colors</h4>
                        <div className={styles.link_grid}>
                            <FooterLink href="/explore?color=black" text="Black" />
                            <FooterLink href="/explore?color=blue" text="Blue" />
                            <FooterLink href="/explore?color=gray" text="Gray" />
                            <FooterLink href="/explore?color=green" text="Green" />
                            <FooterLink href="/explore?color=multi" text="Multi" />
                            <FooterLink href="/explore?color=orange" text="Orange" />
                            <FooterLink href="/explore?color=purple" text="Purple" />
                            <FooterLink href="/explore?color=red" text="Red" />
                            <FooterLink href="/explore?color=white" text="White" />
                            <FooterLink href="/explore?color=yellow" text="Yellow" />
                        </div>
                    </nav>
                </div>
            </footer>
        </>
    );
}
